import http from '../utils/http';
import optimusAxios from './axios';
import authAxios from '../auth/axios';
import axios from 'axios'; // for custom app auth strategy


export default {

	listPolls(params = {}) {
		return optimusAxios({ 
			url: '/polls',
			params})
			.then(http.resolveData, http.rejectData);
	},
	deletePoll({ pollId }) {
		return optimusAxios({
			url: '/polls/' + pollId,
			method: 'DELETE'})
			.then(http.resolveData, http.rejectData);
	},
	updatePollState({ pollId, state }) {
		return optimusAxios({
			url: '/polls/' + pollId,
			method: 'PUT',
			data: {
				state
			}})
			.then(http.resolveData, http.rejectData);
	},
	updatePoll({ pollId, payload}) {
		return optimusAxios({
			url: '/polls/' + pollId,
			method: 'PUT',
			data: payload})
			.then(http.resolveData, http.rejectData);
	},
	getPollDetails({ pollId }) {
		return optimusAxios({ url: `/polls/${pollId}` })
			.then(http.resolveData, http.rejectData);
	},
	getPollLogs({ pollId, params = { limit: -50 } }) {
		return optimusAxios({ 
			url: `/polls/${pollId}/events`,
			params})
			.then(http.resolveData, http.rejectData);
	},
	getExploreItems() {
		return optimusAxios({ url: '/marketplace/items/explore' })
			.then(http.resolveData, http.rejectData);
	},
	getItem(payload) {
		let params = {};
		if (payload.hasOwnProperty('includeApp')) {
			params.includeApp = payload.includeApp;
		}
		if (payload.hasOwnProperty('includeAppIdentity')) {
			params.includeAppIdentity = payload.includeAppIdentity;
		}
		return optimusAxios({
			url: `/marketplace/items/${payload.itemId}`,
			params})
			.then(http.resolveData, http.rejectData);
	},
	addMarketplaceItem(payload) {
		let data = {
			accessKey: payload.accessKey,
			templateValues: payload.templateValues,
			createBucket: payload.createBucket || false,
			cron: payload.cron,
			selectedSignals: payload.selectedSignals
		};
		if (payload.bucketKey && payload.bucketKey.length) {
			data.bucketKey = payload.bucketKey;
		}
		if (payload.selectedBucketId) {
			data.selectedBucketId = payload.selectedBucketId;
		}
		if (payload.name) {
			data.name = payload.name;
		}
		return optimusAxios({
			url: `/marketplace/items/${payload.itemId}/add`,
			data,
			method: 'POST'})
		.then(http.resolveData, http.rejectData);
	},
	getStats({ credits }) {
		let params = {
			credits: credits || false
		};
		return optimusAxios({ 
			url: '/stats',
			params
		})
		.then(http.resolveData, http.rejectData);
	},
	startAppAuthentication({ appId, itemId }) {
		let params = {
			json: true
		};
		return optimusAxios({ 
			url: `/apps/${ itemId || appId }/auth/authenticate`,
			params
		})
		.then(http.resolveData, http.rejectData);
	},
	postAppAuthentication({ appId, itemId, data }) {
		let params = {
			json: true
		};
		return optimusAxios({ 
			url: `/apps/${ itemId || appId }/auth/authenticate`,
			params,
			data,
			method: 'POST'
		})
		.then(http.resolveData, http.rejectData);
	},
	appAuthenticationCustom({ client, data }) {
		// this will be abstracted away but only being used for IS watchdog app right now
		let url = `${authAxios.defaults.baseURL}tokens`;
		return axios({
			method: 'POST',
			url,
			data: {
			  ...data,
			  client,
			  expirySeconds: 0,
			  scope: ['data:bkt:src:read'],
			},
			headers: {
				'Content-Type': 'application/json'
			}
		}).then(http.resolveData, http.rejectData);
	}
};



// WEBPACK FOOTER //
// ./src/modules/optimus/api.js